import { Injectable } from '@angular/core';
import { RestfulEndpoint } from './restful-endpoint.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FileCategoryResponse, FilesListResponse } from '../models/files.model';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(
    private endPoint: RestfulEndpoint,
    protected httpClient: HttpClient,
  ) {}

  private static downloadUrl(url: string, fileName: string): void {
    const a: any = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.style = 'display: none';
    a.click();
    a.remove();
  }

  getAttachedFiles(
    type: 'project' | 'report' | 'category',
    projectId: any,
    id: string,
  ): Observable<FilesListResponse> {
    const body: any = { type };
    if (type === 'project') {
      body.project_id = projectId;
    } else if (type === 'report') {
      body.report_id = id;
    } else if (type === 'category') {
      body.project_id = projectId;
      body.category_id = id;
    }
    return this.endPoint.post('get_attached_files', body);
  }

  getAllFiles(projectId: string): any {
    const body: any = { projectId };
    body.project_id = projectId;
    return this.endPoint.post('get_attached_files_project', body);
  }

  getCategories(project_id: string, parent_id?: string): Observable<FileCategoryResponse> {
    return this.endPoint.post('list_categories', { project_id, parent_id });
  }

  create_attached_files(type: 'project' | 'report' | 'category', id: any, attached: any[]): any {
    const formData = new FormData();
    formData.append('type', type);
    attached.forEach((el) => {
      if (el.name.endsWith('.kmz')) {
        const file = new File([el], el.name, { type: 'application/vnd.google-earth.kmz' });
        formData.append('attached[]', file);
      } else {
        formData.append('attached[]', el);
      }
    });

    if (type === 'project') {
      formData.append('project_id', id);
    } else if (type === 'report') {
      formData.append('report_id', id);
    } else if (type === 'category') {
      formData.append('category_id', id);
    }
    return this.endPoint.post('create_attached_files', formData);
  }

  create_attached_files2(
    attached: any[],
    projectId: string,
    reportId?: string,
    categoryId?: string,
  ): any {
    const formData = new FormData();

    formData.append('type', reportId === '0' ? 'project' : 'report');
    formData.append('project_id', projectId);
    attached.forEach((el) => {
      if (el.name.endsWith('.kmz')) {
        const file = new File([el], el.name, { type: 'application/vnd.google-earth.kmz' });
        formData.append('attached[]', file);
      } else {
        formData.append('attached[]', el);
      }
    });

    if (reportId !== '0') {
      formData.append('report_id', reportId);
    }
    if (categoryId !== '0') {
      formData.append('category_id', categoryId);
    }

    return this.endPoint.post('create_attached_files', formData);
  }

  download(filePath: string, filename: string): void {
    this.httpClient.get(filePath, { responseType: 'blob' }).subscribe((val) => {
      const url = URL.createObjectURL(val);
      FilesService.downloadUrl(url, filename);
      URL.revokeObjectURL(url);
    });
  }
}
